var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-view"},[_c('div',{ref:"mapdiv",staticClass:"map-canvas",attrs:{"id":"mapdiv"}},[_c('v-stage',{ref:"stage",attrs:{"config":_vm.configKonva}},[_c('v-layer',{ref:"layer"},[_vm._l((_vm.nonhome),function(hex){return _c('v-group',{key:hex.id,on:{"click":_vm.handleClick,"tap":_vm.handleClick}},[_c('v-regular-polygon',{attrs:{"config":_vm.hexConfig(hex)}}),(hex.f1 !== 'x')?_c('v-circle',{attrs:{"config":{
              id: hex.f1 + hex.f2 + '-' + hex.f1,
              x: hex.x - hex.r / 3,
              y: hex.y - hex.r / 4,
              radius: hex.r / 4,
              stroke: '#000000',
              fill: _vm.factionColor(hex.f1),
              playable: _vm.available_hex(hex),
              type: _vm.hexConfig(hex).type,
            }}}):_vm._e(),(hex.f2 !== 'x')?_c('v-circle',{attrs:{"config":{
              id: hex.f1 + hex.f2 + '-' + hex.f2,
              x: hex.x + hex.r / 3,
              y: hex.y - hex.r / 4,
              radius: hex.r / 4,
              stroke: '#000000',
              fill: _vm.factionColor(hex.f2),
              playable: _vm.available_hex(hex),
              type: _vm.hexConfig(hex).type,
            }}}):_vm._e(),(_vm.hexPlayed(hex))?_c('v-text',{attrs:{"config":{
              id: hex.f1 + hex.f2 + '-score',
              align: 'center',
              x: hex.x - hex.r / 4,
              y: hex.y + hex.r / 4,
              text: _vm.hexScore(hex),
              fontSize: hex.r / 2,
              fill: '#ffffff',
              fontStyle: 'bold',
              type: _vm.hexConfig(hex).type,
            }}}):_vm._e()],1)}),_vm._l((_vm.home),function(hex){return _c('v-circle',{key:hex.id,attrs:{"config":{
            x: hex.x,
            y: hex.y,
            radius: hex.r / 2,
            fill: hex.hexColor,
          }},on:{"click":_vm.handleClick}})})],2)],1)],1),_c('b-modal',{ref:"matchup-modal",attrs:{"id":"matchup-modal","title":_vm.title,"ok-title":"Play","ok-disabled":!_vm.playable,"ok-variant":_vm.ok_button_variant,"cancel-variant":"danger"},on:{"ok":_vm.selectMatchup}},[_c('div',{staticClass:"choose-modal"},[(_vm.cell_special !== '')?_c('div',[_vm._v(" "+_vm._s(_vm.cell_special)+" ")]):_vm._e(),(_vm.show_factions)?_c('div',[_c('FactionIcon',{attrs:{"icon":_vm.p_faction}}),_vm._v(" vs "),_c('FactionIcon',{attrs:{"icon":_vm.a_faction}})],1):_vm._e(),(_vm.p_score != null)?_c('div',{staticClass:"score-row"},[_c('span',{staticClass:"p-score"},[(_vm.p_won)?_c('b-icon-trophy-fill',{attrs:{"variant":"success"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.p_score)+" ")],1),_c('span',{staticClass:"hyphen"},[_vm._v("-")]),_c('span',{staticClass:"a-score"},[_vm._v(" "+_vm._s(_vm.a_score)+" "),(!_vm.p_won)?_c('b-icon-x-circle-fill',{attrs:{"variant":"danger"}}):_vm._e()],1)]):_vm._e(),(_vm.info_text)?_c('div',{staticClass:"info-text"},[_vm._v(" "+_vm._s(_vm.info_text)+" ")]):_vm._e()])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }